// Groups visible (non-readOnly) fields into rows based on their `order`.
// Fields that share the same `order` are grouped into one row and rendered
// side by side; a field with a unique `order` gets its own full-width row.
export const groupFieldsByOrder = (fields = []) => {
  const visibleFields = fields.filter(field => !field.readOnly);
  const sortedFields = [...visibleFields].sort((a, b) => a.order - b.order);

  return sortedFields.reduce((rows, field) => {
    const lastRow = rows[rows.length - 1];

    if (lastRow && lastRow[0].order === field.order) {
      lastRow.push(field);
    } else {
      rows.push([field]);
    }

    return rows;
  }, []);
};
